<template>
  <div>
    <Form ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="120">
      <FormItem label="角色编码" prop="userRoleCode">
        <Input v-model="addModel.userRoleCode" placeholder="角色编码必须唯一"></Input>
      </FormItem>
      <FormItem label="角色名称" prop="userRoleName">
        <Input v-model="addModel.userRoleName"></Input>
      </FormItem>
      <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel=true">选择机构</Button>
        <span class="ml-5">{{addModel.organName}}</span>
      </FormItem>
      <FormItem label="描述信息">
        <Input v-model="addModel.roleRemark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">确 定</Button>
    </div>

    <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
export default {
  components: { organTree },
  data: function () {
    return {
      treeModel: false,
      organParentName: "",
      addModel: {
        userRoleCode: "",
        userRoleName: "",
        roleRemark: "",
        organID: "",
        organName: "",
      },
      ruleValidate: {
        organName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        userRoleCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        userRoleName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {},

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("role/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    selectTreeData: function (data) {
      this.addModel.organID = data[0].organID;
      this.addModel.organName = data[0].title;
    },
  },
};
</script>
<style scoped>
</style>